import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { SearchItems, SelectedDropdownOption } from "../../../Redux/Action";
function Dropdown() {
  const Indicators = useSelector((state) => state.SelectedDropdownOption);
  const isLoading = useSelector((state) => state.isLoading);

  const dispatch = useDispatch();
  const handleDropdownChange = (event) => {
    dispatch(SelectedDropdownOption(event.target.value));
    dispatch({ type: "SET_EXCHANGE", payload: "NSE" });
    dispatch({ type: "SEARCH_ITEM", payload: "" });
    const searchField = document.getElementById("outlined-basic");
    if (searchField) {
      searchField.value = "";
      dispatch(SearchItems(""));
    }
  };
  return (
    <FormControl
      sx={{
        m: 1,
        minWidth: "50%",
        backgroundColor: "#ccdcff",
        borderRadius: "10px",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
          },
        },
      }}
      size="small"
    >
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={Indicators}
        onChange={handleDropdownChange}
        sx={{
          borderRadius: "10px",
          "&:disabled": {
            backgroundColor: "#e6eeff",
          },
        }}
        disabled={isLoading}
      >
        <MenuItem value="Indicator">Indicator</MenuItem>
        <MenuItem value="SMA">SMA</MenuItem>
        <MenuItem value="EMA">EMA</MenuItem>
        <MenuItem value="RSLEVEL_CLASSIC">R&S level Classic</MenuItem>
        <MenuItem value="RS_LEVEL_FIBBO">R&S level Fibonacci</MenuItem>
        <MenuItem value="Returns">Returns(%)</MenuItem>
        <MenuItem value="Volume_Analysis">Volume Analysis</MenuItem>
        <MenuItem value="Mean_Reversion">Mean Reversion</MenuItem>
        <MenuItem value="Key_Metrics">Key Metrics</MenuItem>
      </Select>
    </FormControl>
  );
}

export default Dropdown;
